<template>
	<div class="edu-card-title">
		{{ campGroup.title }}
	</div>
</template>

<script>
export default {
	name: 'EduCardTitle',
	props: {
		campGroup: {
			type: Object,
			default: () => {},
			required: true,
		},
		partner: {
			type: Object,
			default: () => {},
		},
	},
};
</script>

<style lang="scss" scoped>
@import '../../../scss/base/main';
.edu-card-title {
	@include ellipsis(2);
}
</style>
